import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getMeetFormats from './GetMeetFormatData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const MeetFormatData = {
  INITIAL_STATE,
  getMeetFormats
};

export default MeetFormatData;